"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TableBodyCell = exports.clickFileLink = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const Tooltip_1 = require("../../../../Shared/Components/Tooltip");
const dictionary_1 = require("../../TableCore/dictionary");
const ValidForTooltip_1 = require("../../ValidForTooltip/ValidForTooltip");
const MosaicIcon_1 = require("../../../../Shared/Components/MosaicIcon");
const clickFileLink = (item) => {
    // skip code execution if dataLayer is not set
    if (!(0, app_1.isDataLayerSet)() || !item || !item.fileType) {
        return null;
    }
    if (item.fileType.toLowerCase() === 'ipaper') {
        app_1.GTM.iPaper({
            name: item.name,
            url: item.downloadUrl,
        });
    }
    else {
        app_1.GTM.download({
            category: item.type,
            name: item.name,
            page: window.location.href,
            path: item.downloadUrl,
            type: item.fileType,
        });
    }
};
exports.clickFileLink = clickFileLink;
const getLanguagesLabel = (languages, multiLanguageLabel, isOnGlobalLanguage) => {
    let label = '';
    if (languages) {
        if (languages.length === 1) {
            label = languages[0];
        }
        else if (languages.length > 1 || isOnGlobalLanguage) {
            label = multiLanguageLabel;
        }
    }
    return label;
};
const TableBodyCell = ({ cellInfo, cellName, isDesktop, clickableElementsTabIndex, dictionary, }) => {
    return React.useMemo(() => {
        switch (cellName) {
            case dictionary_1.tableDictionary.name:
                return ((0, jsx_runtime_1.jsxs)("span", { className: "inline-block max-sm:break-all", children: [(0, jsx_runtime_1.jsx)("span", { className: "name", children: cellInfo[cellName] }), cellInfo.authority ? ((0, jsx_runtime_1.jsxs)("span", { children: [(0, jsx_runtime_1.jsx)("br", {}), (0, jsx_runtime_1.jsx)("span", { className: "authority", children: cellInfo.authority })] })) : null, cellInfo.description ? ((0, jsx_runtime_1.jsx)("div", { className: "description", children: isDesktopTooltip(isDesktop, cellInfo) })) : null] }));
            case dictionary_1.tableDictionary.download:
                return cellInfo.downloadUrl ? ((0, jsx_runtime_1.jsx)("div", { className: "td-download", children: (0, jsx_runtime_1.jsxs)("a", { href: cellInfo.downloadUrl, target: "_blank", rel: "noopener noreferrer", onClick: () => (0, exports.clickFileLink)(cellInfo), tabIndex: clickableElementsTabIndex, className: "gap-5xs flex items-center justify-end sm:justify-start group", children: [(0, jsx_runtime_1.jsx)("span", { className: "hover:underline", children: cellInfo.size }), (0, jsx_runtime_1.jsx)("span", { className: "text-icon-accent-01-primary p-4xs in-[a:hover]:bg-fill-secondary-hovered active:bg-fill-secondary-pressed rounded-full", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { className: "icon-md", name: "file-download-outline" }) })] }) })) : ((0, jsx_runtime_1.jsx)("div", { className: "table-body-cell__empty", children: "-" }));
            case dictionary_1.tableDictionary.validFor:
                const { globalTooltipMessage, multipleTooltipMessage } = dictionary;
                const properTitle = cellInfo.validForGlobal ? globalTooltipMessage : multipleTooltipMessage;
                const showValidForIcon = (item) => {
                    return item.validForGlobal || (item.validForList && item.validForList.length > 1);
                };
                return ((0, jsx_runtime_1.jsxs)("div", { className: "td-valid-for gap-5xs flex items-center", children: [(0, jsx_runtime_1.jsx)("span", { children: cellInfo[cellName] }), showValidForIcon(cellInfo) && ((0, jsx_runtime_1.jsx)("div", { className: "table--nested-cell right-cell text-right align-top", children: (0, jsx_runtime_1.jsx)(Tooltip_1.default, { className: "text-icon-accent-01-primary p-4xs hover:bg-fill-secondary-hovered active:bg-fill-secondary-pressed rounded-full", wrapperAs: "span", contentClassName: "table__tooltip", content: (0, ValidForTooltip_1.ValidForTooltip)(cellInfo.validForGlobal, properTitle, cellInfo.validForList), isPortalRendering: true, children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { className: "icon-md", name: "info-outline" }) }) }))] }));
            case dictionary_1.tableDictionary.updated:
                return (0, jsx_runtime_1.jsx)("span", { className: "td-updated", children: cellInfo[cellName] });
            case dictionary_1.tableDictionary.fileType:
                return (0, jsx_runtime_1.jsx)("span", { className: "td-filetype", children: cellInfo[cellName] });
            case dictionary_1.tableDictionary.type:
                return (0, jsx_runtime_1.jsx)("span", { className: "td-type", children: cellInfo[cellName] });
            case dictionary_1.tableDictionary.status:
                return (0, jsx_runtime_1.jsx)("span", { className: "td-status", children: cellInfo[cellName].title });
            case dictionary_1.tableDictionary.languages:
                const languages = cellInfo.languages;
                const label = getLanguagesLabel(languages, dictionary.multilanguageLabel, cellInfo.isOnGlobalLanguage);
                return (0, jsx_runtime_1.jsx)("span", { children: label ? label : (0, jsx_runtime_1.jsx)("span", { className: "table-body-cell__empty", children: "-" }) });
            default:
                return (0, jsx_runtime_1.jsx)("span", { children: cellInfo[cellName] });
        }
    }, [cellInfo, cellName, clickableElementsTabIndex, isDesktop, dictionary]);
};
exports.TableBodyCell = TableBodyCell;
function isDesktopTooltip(isDesktop, cellInfo) {
    return isDesktop ? ((0, jsx_runtime_1.jsx)(Tooltip_1.default, { className: "icon icon-info", content: cellInfo.description, wrapperAs: "span", isPortalRendering: true })) : null;
}
